/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const DEFAULT_LOCALE = 'en';
export const appName = 'CurriculumManager';

export const DEFAULT_DROPDOWN_ID = '-1';
export const DEFAULT_DROPDOWN_ID_INT = -1;
export const GLOBAL_CURRICULUM_ID = '1';
export const COUNTRY_CURRICULUM_ID = '0';

export const CURRICULUM_TABS = [
    { id: 1, name: 'Curriculums', route: 'curriculum-list' },
    { id: 2, name: 'Master Courses', route: 'master-courses' },
    { id: 3, name: 'Curriculum alignment documents', route: 'curriculum-documents' }
];

export const FILE_TYPES = {
    PDF: 'application/pdf'
};



// WEBPACK FOOTER //
// ./app/constants.js